import { useT } from "../i18n/LanguageContext";

export const HowItWorks = () => {
  const { t } = useT();
  return (
    <section id="ablauf" data-testid="how-section" className="relative py-24 sm:py-32 bg-white border-y border-[var(--al-line)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <span className="al-tag">{t.how.tag}</span>
            <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight">
              {t.how.h2a}<span className="al-grad-text">{t.how.h2b}</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-slate-600 leading-relaxed">{t.how.sub}</p>
        </div>

        <ol className="mt-14 grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {t.how.steps.map((s, i) => (
            <li key={s.n} data-testid={`how-step-${i + 1}`} className="al-card p-6 relative al-rise" style={{ animationDelay: `${i * 80}ms` }}>
              <span className="al-step-num">{s.n}</span>
              <h3 className="mt-5 font-display font-semibold text-lg leading-snug">{s.title}</h3>
              <p className="mt-2.5 text-[14px] text-slate-600 leading-relaxed">{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
